import PortalFetchJson from './PortalFetchJson'

var gradYears = []
var currentYear = (new Date()).getFullYear()
for (let k = currentYear; k >= currentYear - 70; k--) {
  gradYears.push(k)
}
function fieldListItemConverter (item) {
  return {
    label: item.display,
    value: item.list_mapping_id && typeof item.list_mapping_id === 'number' && !item.list_mapping_value.includes('campus-type') ? item.list_mapping_id : item.value,
    rawValue: item.value,
    mappingValue: item.list_mapping_value
  }
}

function fieldTypeConverter (type, postKey) {
  switch (type) {
    case 'GenericRadioList':
      if (postKey === 'lead_education[subject_ids]') {
        return 'AreaOfStudyOptionButtons'
      }
      return 'OptionButtons'
    case 'GenericDropdown':
      return 'DropDown'
    default:
      return type
  }
}

function getPlaceholder (field) {
  if (field.form_field_type_name === 'GenericDropdown') {
    return field.name.includes('year') ? 'Select Year' : 'Please Select'
  }
  return null
}

async function GetAdditionalQuestions (customerId, callDirection) {
  if (customerId !== 0) {
    var fieldsResults = await PortalFetchJson(`additional_info_fields?consumer_id=${customerId}&call_direction=${callDirection}`)
    if (!fieldsResults.form.form_groups) {
      fieldsResults.form.form_groups = fieldsResults.form_groups.sort((a, b) => a.sequence - b.sequence)
    } else {
      fieldsResults.form.form_groups = fieldsResults.form.form_groups.sort((a, b) => a.sequence - b.sequence)
    }
    var questionArray = []
    var pages = []
    for (var groupIndex = 0; groupIndex < fieldsResults.form.form_groups.length; groupIndex++) {
      var group = fieldsResults.form.form_groups[groupIndex]
      pages.push({ title: group.name, number: groupIndex })
      for (var field of group.form_fields) {
        var newQuestion = {
          page: groupIndex,
          label: field.label_text,
          field: field.post_key,
          fieldName: field.name,
          model: field.model,
          values: field.form_list_items?.map(item => fieldListItemConverter(item)) ?? [],
          type: fieldTypeConverter(field.form_field_type_name, field.post_key),
          placeholder: getPlaceholder(field),
          reverseSort: field.name.includes('year'),
          required: true,
          displayName: field.label_text,
          defaultLabel: field.default_label,
          listMappingName: null,
          prefilledValue: field.prefilled_value
        }
        if (field.name === 'military_type') {
          newQuestion.label = 'Which branch or what is your current status?'
          questionArray.push({
            page: groupIndex,
            label: field.label_text,
            field: 'military_status',
            values: [{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' }],
            type: 'OptionButtons',
            listMappingName: null,
            placeholder: null,
            required: true
          })
          newQuestion.dependsOn = { field: 'military_status', values: ['yes'] }
        }
        questionArray.push(newQuestion)
      }
    }
    return { pages, questionArray }
  }
  return {}
}

export default GetAdditionalQuestions
